
<div>
	<div class="dwform" style="padding-right: 15px; padding-left: 5px;">

		<div class="dwform-cell-nopadding" style="min-width: 510px;">
			<div class="dwform-row-double-gap"></div>
			<div class="dwform-row">
				<label class="label-field" style="vertical-align: top;">Description:</label> <span
					class="form-required">*</span>
				<input id="desc" #desc
					class="input-field-shortest" style="width: 350px;"
					[(ngModel)]="valDescription" placeholder="<Description>" type="text">
			</div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>
	</div>
	<!----------------------->
	<!-- ERROR LINE --------->
	<!----------------------->
	<div class="error-line" [hidden]='!strErr.length'
		style="text-align: left">{{strErr}}</div>
	<!----------------------->
	<!-- SAVE STRIP        -->
	<!----------------------->
	<div class="save-close-strip" style="bottom: 10px;">

		<button mat-button class="command-button" 
			(click)="submitRecord()" matTooltip="Submit the selected record"
			mat-button>
			<mat-icon>check_circle_outline</mat-icon>
			Submit
		</button>
		<button mat-button class="command-button"
			(click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
			<mat-icon>highlight_off</mat-icon>
			Cancel
		</button>
	</div>
</div>